import {
  CATEGORIE_DIVERS, CATEGORIE_ENCART, CATEGORIE_LOCATION,
  CATEGORIE_DISPOSITIF,
} from '@/configuration/catalogue/produitConf';
import genererLigneCommandeDispositif from '@/services/devisCommandes/genererLigneCommandeDispositif';

export default function updateInfoSousLigneRegroupement(option, ligne, updatePU, tauxTvaParDefaut) {
  ligne.produit = option.produit;
  ligne.typeProduit = option.type;
  ligne.produitId = option.id;
  ligne.search = option.title;
  ligne.libelle = option.libelle;
  ligne.tauxTva = tauxTvaParDefaut || option.produit.tauxTva;
  if (!ligne.libelle) ligne.libelle = option.produit.libelle;
  if (!updatePU) return;
  if (option.type === CATEGORIE_LOCATION) {
    ligne.prixUnitaire = option.produit.produitLocation.prixUnitaire;
  } else if (option.type === CATEGORIE_DIVERS) {
    ligne.prixUnitaire = option.produit.produitDivers.prixUnitaire;
    ligne.quantite = option.produit.produitDivers.quantite;
  } else if (option.type === CATEGORIE_ENCART) {
    ligne.prixUnitaire = option.produit.prixUnitaire;
  } else if (option.type === CATEGORIE_DISPOSITIF) {
    ligne.prixUnitaire = option.produit.produitDispositif.prixUnitaire;
    const ligneDispositif = genererLigneCommandeDispositif();
    ligneDispositif.dispositifSupportId = option.produit.produitDispositif.dispositifSupportId;
    ligneDispositif.dispositifTypeId = option.produit.produitDispositif.dispositifTypeId;
    ligneDispositif.materielTypeId = option.produit.produitDispositif.materielTypeId;
    ligneDispositif.materielFormatId = option.produit.produitDispositif.materielFormatId;
    ligneDispositif.isDoubleFace = option.produit.produitDispositif.isDoubleFace;
    ligneDispositif.nomenclatureTypeId = option.produit.produitDispositif.nomenclatureTypeId;
    ligneDispositif.materielEclaire = option.produit.produitDispositif.materielEclaire;
    if (option.produit.produitDispositif?.nomenclature) {
      ligneDispositif.nomenclature = JSON.parse(
        option.produit.produitDispositif.nomenclature);
    }
    ligne.ligneCommandeDispositif = ligneDispositif;
  }
}
